import React from "react";
import { useTranslation } from "react-i18next";
const MarketBasketAnalysisPatterns = () => {
  const { t } = useTranslation();
  const data = [
    [ "1", "[cips | ekmek | kola]", "3", "5", "0.5" ],
    [ "2", "[cips | ekmek]", "2", "6", "0.6" ],
    [ "3", "[ekmek | kola]", "2", "6", "0.6" ],
    [ "4", "[cips | kola]", "2", "5", "0.5" ],
    [ "5", "[ekmek | su]", "2", "5", "0.5" ],    
    ]

  return (
    <div className="w-[50%] p-6 flex flex-col items-center bg-gray-50">
      <div className="border border-gray-400 rounded-lg p-6 w-full bg-white shadow-lg">
        {/* Header */}
        <h2 className="text-xl font-bold text-blue-600 text-center">{t("Sık_Oge_Setleri")}</h2>
        
        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="text-lg w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-sky-700 text-sky-100">
                <th className="border border-gray-300 p-2">{t("No.")}</th>
                <th className="border border-gray-300 p-2">{t("Oge_Seti")}</th>
                <th className="border border-gray-300 p-2">{t("Uzunluk")}</th>
                <th className="border border-gray-300 p-2">{t("Sıklık_Sayısı")}</th>
                <th className="border border-gray-300 p-2">{t("Sıklık_Oranı")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index} className="text-gray-700">
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className={`text-lg text-center border border-gray-300 p-2`}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
      </div>

    </div>
  );
};

export default MarketBasketAnalysisPatterns;
